import { HttpClient, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { environment } from "@env";
import {
  ProductDTO,
  SaveProductDTO,
  SearchProductParams,
  ProductListResponse
} from "../../modules/private/modules/product/models/product-form-dto";
import { PageManager } from "@shared/models/page-manager";

@Injectable({
  providedIn: "root"
})
export class ProductService {
  private productUrl = "manage-products/";

  constructor(private http: HttpClient) {}

  saveProduct(dto: SaveProductDTO): Observable<any> {
    return this.http.post<any>(environment.apiUrl + this.productUrl, dto);
  }

  edit(id: number, dto: SaveProductDTO): Observable<any> {
    return this.http.put<any>(
      `${environment.apiUrl}${this.productUrl}${id}`,
      dto
    );
  }

  findAll(): Observable<ProductDTO[]> {
    return this.http.get<ProductDTO[]>(`/api/products`);
  }

  findById(id: number): Observable<ProductDTO> {
    const params = new HttpParams().set("id", id.toString());
    return this.http
      .get<{ content: ProductDTO[] }>(
        `${environment.apiUrl}${this.productUrl}`,
        { params }
      )
      .pipe(map((response) => response.content[0]));
  }

  delete(id: number): Observable<any> {
    return this.http.delete<any>(
      `${environment.apiUrl}${this.productUrl}${id}`
    );
  }

  findByFilters(
    filters: SearchProductParams,
    pageManager: PageManager,
    sort: string
  ): Observable<ProductListResponse> {
    let params = new HttpParams();

    if (filters.id != null) {
      params = params.append("id", filters.id.toString());
    }
    if (filters.productName)
      params = params.append("productName", filters.productName);
    if (filters.description)
      params = params.append("description", filters.description);
    if (filters.recommendations)
      params = params.append("recommendations", filters.recommendations);

    params = params.append("page", pageManager.pageIndex.toString());
    params = params.append("size", pageManager.pageSize.toString());

    if (sort) params = params.append("sort", sort);

    return this.http.get<ProductListResponse>(
      environment.apiUrl + this.productUrl,
      { params }
    );
  }
}
